import React from 'react';
import { withTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = makeStyles((theme) => ({
    inputRoot: {
        color: 'inherit',
        "& .MuiOutlinedInput-input": {
            color: "white"
          },
          "& .MuiInputLabel-root": {
            color: "white"
          },
          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
          },
          "&:hover .MuiOutlinedInput-input": {
            color: "white"
          },
          "&:hover .MuiInputLabel-root": {
            color: "white"
          },
          "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
            color: "white"
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "white"
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "white"
          }
    },
}));

function ProjectSelect(props) {
    const classes = useStyles();
    const { defaultProjectId, projects, onChangeProject } = props;
    const [project, setProject] = React.useState(defaultProjectId);

    /**
     * Funzione per la gestione della selezione del progetto
     * @param {*} event
     */
    const handleChange = (event) => {
        setProject(event.target.value);
        localStorage.setItem("currentProjectId", event.target.value);
        props.onChangeProject(event.target.value);
    }

    // Inizializzazione dei contenuti del menu select
    let items = props.projects.map((project) => <MenuItem key={project.uuid} value={project.uuid}>{project.name}</MenuItem>);
    return (
        <FormControl fullWidth
            sx={{
                maxWidth: {
                    xs: '60%',
                    sm: '70%',
                    md: '50%',
                    lg: '480px',
                    xl: '480px'
                }
            }}
            className={classes.inputRoot}
            variant="outlined"
            size="small">
            <InputLabel id="project-appbar-select-label">{props.t("projects")}</InputLabel>
            <Select
                labelId="project-appbar-select-label"
                value={project}
                label={props.t("projects")}
                onChange={handleChange}>
                {items}
            </Select>
        </FormControl>
    );
}

export default withTranslation()(ProjectSelect);
